import request from 'yeself-common/utils/RequestUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const fetchApplicationListService = () =>
    request.get(`${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications`);

export const createNewApplicationRequest = (payload) =>
    request.post(`${EnvironmentConfiguration.API_MANAGE_SLUG}/manage/applications`, payload);

export const fetchNotificationsRequest = (userId) =>
    request.get(`${EnvironmentConfiguration.API_NOTIFICATION_SLUG}/accounts/${userId}/notifications`);

export const updateNotificationsRequest = (userId, notificationId, data) =>
    request.put(
        `${EnvironmentConfiguration.API_NOTIFICATION_SLUG}/accounts/${userId}/notifications/${notificationId}/state`,
        data,
        {
            header: { 'Content-Type': 'application/json' },
        }
    );
